(function($) {
	'use strict';
	$().UItoTop({ easingType: 'easeOutQuart' });
	return false;
})(jQuery);